import type {ReferenceType} from './attachment-refs'

const PATH_TYPE_TO_REFERENCE_TYPE: Record<string, ReferenceType | undefined> = {
  issues: 'issue',
  pull: 'pr',
  discussions: 'discussion',
}

export interface ParsedGitHubReference {
  owner: string
  repo: string
  type: ReferenceType
  number: number
  url: string
}

export function parsePastedGitHubReference(text: string, currentOrigin: string): ParsedGitHubReference | null {
  let parsed: URL
  try {
    parsed = new URL(text, currentOrigin)
  } catch {
    return null
  }

  if (parsed.search || parsed.hash || !currentOrigin || parsed.origin !== currentOrigin) return null
  const segments = parsed.pathname.split('/').filter(Boolean)
  if (segments.length !== 4) return null
  const [owner, repo, pathType, idSegment] = segments as [string, string, string, string]
  const type = PATH_TYPE_TO_REFERENCE_TYPE[pathType]
  if (!type || !/^\d+$/.test(idSegment)) return null
  const number = Number(idSegment)
  if (!Number.isInteger(number) || number <= 0) return null
  return {owner, repo, type, number, url: `${currentOrigin}/${owner}/${repo}/${pathType}/${number}`}
}
